import { theme } from '@theme';

export const helpCenterQuestionItem = {
  boxShadow: 'unset',
  borderRadius: '0 !important',
  '& .MuiAccordionSummary-content': {
    marginBlock: '24px'
  },
  '& .MuiAccordionSummary-content.Mui-expanded': {
    marginBlock: '24px'
  },
  '& .MuiAccordionDetails-root': {
    padding: 0
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    marginLeft: '12px'
  },
  '&.Mui-expanded:before': {
    opacity: 1
  },
  '&.Mui-expanded': {
    margin: '0 0 24px'
  }
};

const helpCenterQuestionItemDetailsContent = {
  color: theme.palette.common.darkGrey12,
  display: 'block',
  lineHeight: 1.5
};

export const helpCenterQuestionItemDetails = {
  '>p, p': {
    ...helpCenterQuestionItemDetailsContent,
    margin: '0 0 15px'
  },
  'ul, ol': {
    paddingLeft: '20px'
  },
  li: {
    ...helpCenterQuestionItemDetailsContent,
    marginBottom: '5px',
    display: 'list-item',
    '> p': {
      marginBottom: '0'
    }
  },
  a: {
    ...helpCenterQuestionItemDetailsContent,
    textDecoration: 'underline',
    cursor: 'pointer',
    display: 'inline'
  },
  '> *:last-child': {
    marginBottom: 0
  }
};
